"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2Context = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const types_1 = require("../types");
const fetcher_1 = require("../fetcher");
const base_context_1 = require("./base-context");
const methods_1 = require("../methods");
class V2Context extends base_context_1.BaseContext {
    static from(connection, wallet, fetcher = new fetcher_1.AccountFetcher(connection), opts = anchor_1.AnchorProvider.defaultOptions()) {
        const provider = new anchor_1.AnchorProvider(connection, wallet, opts);
        const program = new anchor_1.Program(types_1.V2StakingIDL, provider);
        return new V2Context(provider, wallet, program, fetcher, opts);
    }
    static withProvider(provider, fetcher = new fetcher_1.AccountFetcher(provider.connection), opts = anchor_1.AnchorProvider.defaultOptions()) {
        const program = new anchor_1.Program(types_1.V2StakingIDL, provider);
        return new V2Context(provider, provider.wallet, program, fetcher, opts);
    }
    constructor(provider, wallet, program, fetcher, opts) {
        super(provider, wallet, fetcher, opts);
        this.program = program;
        this.methods = new methods_1.V2Methods(this);
    }
}
exports.V2Context = V2Context;
